/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

var localeOption = {
  name: 'localeOption',

  lookup(options) {
    let found;

    if (options && options.locale) {
      found = options.locale;
    }

    return found;
  }
};

export default localeOption;
